import React from 'react';

import { INextStepProps } from '@domain/interfaces/onboarding/INextStep';

import { EButtonSize } from '@domain/enums/components/EButton';
import * as S from './styles';

const NextStep: React.FC<INextStepProps> = ({
  onClick,
  disabled,
  isLoading,
  type = 'button',
  children,
  textColor,
}) => {
  return (
    <S.Wrapper>
      <S.Button
        buttonSize={EButtonSize.SMALL}
        textColor={textColor}
        onClick={onClick}
        disabled={disabled}
        isLoading={isLoading}
        type={type}
      >
        {children}
      </S.Button>
    </S.Wrapper>
  );
};

export default NextStep;
